import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey:            "AIzaSyCPLj_a1xBOYz-C9d6gBDkxtNHzV3itO7k",
  authDomain:        "xylo-wallet.firebaseapp.com",
  projectId:         "xylo-wallet",
  storageBucket:     "xylo-wallet.firebasestorage.app",
  messagingSenderId: "418782537866",
  appId:             "1:418782537866:web:7fe73c02ea30822dce6573",
  measurementId:     "G-GVS7G1E49D"
};

const app = initializeApp(firebaseConfig);

export const auth     = getAuth(app);
export const db       = getFirestore(app);
export const provider = new GoogleAuthProvider();

// Always show Google account picker — never auto-login
provider.setCustomParameters({ prompt: "select_account" });
